import { DatabaseProvider } from '../DatabaseProvider'
import { mockTables } from '../mock'
import { DatabaseFormDialog, type DatabaseFormDialogProps } from './dialog'

export default function DatabaseFormDialogWrapper(
  props: DatabaseFormDialogProps,
) {
  return (
    <DatabaseProvider tableName={props.table.db_table_name}>
      <DatabaseFormDialog {...props} />
    </DatabaseProvider>
  )
}
